"use client";

import dynamic from "next/dynamic";

export const CustomPricingCardsDynamic = dynamic(() =>
  import("@ui/components/pricing/CustomPricingCards").then(mod => ({ default: mod.CustomPricingCards })),
);

export const PricingCardsSectionDynamic = dynamic(() =>
  import("@ui/components/pricing/PricingCardsSection").then(mod => ({ default: mod.PricingCardsSection })),
);
